import { render, staticRenderFns } from "./FormTwoB.vue?vue&type=template&id=33b54e88&scoped=true&"
import script from "./FormTwoB.vue?vue&type=script&lang=js&"
export * from "./FormTwoB.vue?vue&type=script&lang=js&"
import style0 from "./FormTwoB.vue?vue&type=style&index=0&id=33b54e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b54e88",
  null
  
)

export default component.exports